import { render, staticRenderFns } from "./BindEventsModal.vue?vue&type=template&id=410dc17e&"
import script from "./BindEventsModal.vue?vue&type=script&lang=js&"
export * from "./BindEventsModal.vue?vue&type=script&lang=js&"
import style0 from "./BindEventsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports